let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("f5JIU")).then(() => parcelRequire('i1B53'));